import { render } from "./TrainingIndexView.vue?vue&type=template&id=8a5bab8a&scoped=true"
import script from "./TrainingIndexView.vue?vue&type=script&lang=js"
export * from "./TrainingIndexView.vue?vue&type=script&lang=js"

import "./TrainingIndexView.vue?vue&type=style&index=0&id=8a5bab8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5bab8a"]])

export default __exports__